import { Card, CardContent, colors, Divider, Grid, StepContent, Stepper, Typography, Step, StepLabel, Chip, StepConnector } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Page } from "components";
import PropTypes from "prop-types";
import React, { useState } from "react";


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  divider2: {
    marginBottom: theme.spacing(2)
  },
  card: {
    marginBottom: theme.spacing(2)
  },
  chip: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: 5
  },
  red: {
    backgroundColor: colors.red["200"],
  },
  content: {
    marginLeft: 18
  },
}));

const CMS_VERSIONS = [{
  version: "1.0.1",
  title: "First Release",
  content: "CMS is launched together with app",
  date: "9/12/2019"
},
{
  version: "1.0.2",
  title: "More Help",
  content: "Included help page with FAQs and also added changelog",
  date: "13/12/2019"
},
{
  version: "1.0.3",
  title: "Transaction Infos",
  content: "Added student info in transaction summary",
  date: "6/1/2020"
},
{
  version: "1.0.4",
  title: "Curriculum addition",
  content: "Added mastery/module/routine creation, and reordering of masteries",
  date: "27/2/2020"
},
{
  version: "1.0.5",
  title: "Delete functions",
  content: "Added delete functions to most models, add warning message for editing slots",
  date: "3/3/2020"
},
{
  version: "1.0.6",
  title: "Improve slot tooltip, add student change mastery function",
  content: "Slot tooltip now lists assigned teachers, student detail now has function to change active mastery.",
  date: "16/4/2020"
},
{
  version: "1.1.1",
  title: "Add inventories system",
  content: "Added relevant pages for inventories, item classes, payment options, and pass purchases",
  date: "20/5/2020"
},
{
  version: "1.1.2",
  title: "Show only scheduled/concluded slots",
  content: "Show only scheduled/concluded slots in lesson overview",
  date: "29/5/2020"
},
{
  version: "1.1.3",
  title: "Fix booking prices",
  content: "Show prices in class passes instead of XXC of lesson's price when booked via class pass",
  date: "21/6/2020"
},
{
  version: "1.2.1",
  title: "Add lesson masteries",
  content: "Add lesson masteries link, deprecate old lesson modules link",
  date: "14/7/2020"
},
];

const APP_VERSIONS = [{
  version: "2.3.7 (30)",
  title: "First Release",
  content: "Android app is released on Google Play Store while iOS app is pending Apple App Store approval.",
  date: "9/12/2019"
},
{
  version: "2.4.1 (33)",
  title: "Phase 2 Prelaunch",
  content: "Guest screens with mastery level, lessons, and coach listings. Wallet Top-up option without saving card. Remember-me feature for login screen that remembers user email. Remove activities from public screens.",
  date: "20/2/2020"
},
{
  version: "2.4.2 (34)",
  title: "Activity Upload for Coach",
  content: "Implement Activity Upload for Coach",
  date: "1/3/2020"
},
{
  version: "2.5.1 (35)",
  title: "UI Revamp",
  content: "Revamp Teacher UI screens and process-booking flow. Fix android bottom tab allowance for android with soft navigation bar. Verified user activities tab only show activities of students according to their booked lessonslots.",
  date: "16/3/2020"
},
{
  version: "2.5.2 (36)",
  title: "Tweak process for booking flow",
  content: "Tweak process-booking flow and UI on Teacher UI. Add load more function to lessonslots listing.",
  date: "23/3/2020"
},
{
  version: "2.5.4 (38)",
  title: "Bugfix",
  content: "Fix error message returned upon clicking activities tab on scenario with no activities.",
  date: "27/4/2020"
}
]



const Changelog = props => {
  const classes = useStyles();
  const [activeStepCMS, setActiveStepCMS] = useState(CMS_VERSIONS.length - 1);
  const [activeStepApp, setActiveStepApp] = useState(APP_VERSIONS.length - 1);
  return (
    <Page className={classes.root} title="Help" >
      <Typography variant="h2">Changelog</Typography>
      <Divider className={classes.divider} />
      <Grid container spacing={3}>
        <Grid xl={6} lg={6} md={6} sm={12} item>
          <Card className={classes.card}>
            <CardContent>
              <Typography gutterBottom variant="h5">CMS</Typography>
              <Divider className={classes.divider2} />
              <Stepper orientation="vertical" activeStep={activeStepCMS} connector={<Connector />}>
                {CMS_VERSIONS.map((ver, index) => (
                  <Step key={index}>
                    <StepLabel onClick={() => setActiveStepCMS(index)} StepIconProps={{ version: ver.version }} StepIconComponent={Icon}>{ver.title} ({ver.date})</StepLabel>
                    <StepContent className={classes.content}>
                      {ver.content}
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </CardContent>
          </Card>
        </Grid>
        <Grid xl={6} lg={6} md={6} sm={12} item>
          <Card className={classes.card}>
            <CardContent>
              <Typography gutterBottom variant="h5">App</Typography>
              <Divider className={classes.divider2} />
              <Stepper orientation="vertical" activeStep={activeStepApp} connector={<Connector />}>
                {APP_VERSIONS.map((ver, index) => (
                  <Step key={index}>
                    <StepLabel onClick={() => setActiveStepApp(index)} StepIconProps={{ version: ver.version }} StepIconComponent={Icon}>{ver.title} ({ver.date})</StepLabel>
                    <StepContent className={classes.content}>
                      {ver.content}
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Page>
  );
};

const Icon = props => {
  return <Chip label={props.version} />
}

const Connector = withStyles({
  lineVertical: {
    marginLeft: 6
  },
})(StepConnector);

Changelog.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default Changelog;
